export default __webpack_public_path__ + "static/SR USA - Halal (en ingelés) - Certificado-4c04464a8ba3102a70d71a3fbd388351.pdf";